"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M11 5h2v3h-2V5z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2C6.3431 2 5 3.3432 5 5v10c0 1.6569 1.3431 3 3 3h.0037a4.9999 4.9999 0 0 0 .6517 2.2832l.2208.3876c.4192.7359.7518 1.5175.9915 2.3292h2.0751l-.0783-.2886a12.995 12.995 0 0 0-1.2505-3.0305l-.2208-.3876A3 3 0 0 1 10 17.8085v-4.3073a.5.5 0 0 1 1 0v4.5h2V18c1.6569 0 3-1.3431 3-3V8.7532l1.7832 3.5514a1 1 0 0 1 .0809.6728l-1.764 7.6753a3.0007 3.0007 0 0 0-.0558 1.0213L16.1997 23h2.0137l-.1827-1.5589a.9967.9967 0 0 1 .0186-.3404l1.764-7.6754a3 3 0 0 0-.2428-2.0181l-3.8238-7.6156C15.2818 2.7366 14.2269 2 13 2H8zm5 2H8c-.5523 0-1 .4477-1 1v10c0 .5523.4477 1 1 1v-2.4988c0-1.3807 1.1193-2.5 2.5-2.5s2.5 1.1193 2.5 2.5V16c.5523 0 1-.4477 1-1V5c0-.5609-.4712-1-1-1z"
  })];
};

exports.default = _default;